


import React from "react";
import { IonPage, IonContent,  IonFooter, IonButton, IonHeader, IonToolbar, IonGrid, IonRow, IonCol, IonInput } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";


import './NamePage.css';
import { useAppDispatch, useAppSelector } from "../../../services/redux/hook";
import { setUser } from "../../../services/redux/slices/user/user";
import { ErrorMessage } from "@hookform/error-message";
import AppHeader from "../../../components/AppHeader/AppHeader";
import { useHistory } from "react-router";


const NamePage: React.FC<any> = () => {

    const { t, i18n } = useTranslation();
    const user = useAppSelector((state) => state.user);
    const dispatch = useAppDispatch();
    const history = useHistory();
	
    const {
        handleSubmit,
        control,
        setValue,
        register,
        getValues,
        formState: { errors }
    } = useForm({
        defaultValues: {
            name: '',
            last_name: ''
        }
    });

    const onSubmit = async () => {

        const data = getValues();
        const updatedUser = { ...user }

        updatedUser.first_name = data.name;
        updatedUser.last_name = data.last_name;

        dispatch(setUser(updatedUser))

        history.push('/signup/email')
    

    }
    return (
       
       <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 18 }}>
            
            <IonPage>

                <IonHeader className="ion-no-border">

                    <AppHeader
                        title={t('registration.name.HEADER') as string}
                        goBack={true}
                        style={{marginBottom:'5%'}}
                    >
                    </AppHeader>


                </IonHeader>
                <IonContent scrollY={false} className="ion-padding">
                    <IonGrid>

                        <IonRow>

                            <IonCol>

                            <IonInput
                            className="ion-text-start"
                            fill="outline"
                            mode="md"
                            labelPlacement="floating"
                            clearOnEdit={true}
                            label={t('registration.name.FIRST_NAME') as string}
                            {...register('name', {
                                required: `${t('registration.name.ERROR_REQUIRED')}`,
                                pattern: {
                                    value: /^[^\n0-9_!¡?÷?¿\/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/i,
                                    message: `${t('registration.name.NAME_LAST_NAME_INVALID')}`
                                }
                            })} />

                            <ErrorMessage
                                errors={errors}
                                name="name"
                                as={<div style={{ color: 'red' }} />}
                            />

                            </IonCol>

                      
                        </IonRow>
                        
                        <IonRow style={{marginTop:'5%'}}>
                            <IonCol>

                            <IonInput
                                className="ion-text-start"
                                mode="md"
                                fill="outline"
                                label={t('registration.name.LAST_NAME') as string}
                                clearOnEdit={true}
                                labelPlacement="floating"
                                {...register('last_name', {
                                    required: `${t('registration.name.ERROR_REQUIRED')}`,
                                    pattern: {
                                        value: /^[^\n0-9_!¡?÷?¿\/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/i,
                                        message: `${t('registration.name.NAME_LAST_NAME_INVALID')}`
                                    }
                                })} />

                                <ErrorMessage
                                    errors={errors}
                                    name="last_name"
                                    as={<div style={{ color: 'red' }} />}
                                />
                            </IonCol>
                            
                        </IonRow>
                    
                    </IonGrid>

                </IonContent>

                <IonFooter className="ion-no-border" >
                    <IonToolbar>
                        <IonButton
                            color='primary'
                            type="submit"
                            expand="block"
                            id="pageFooterButton">
                            {t('registration.name.BTN_CONT')}
                        </IonButton>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </form>
    )
}


export default NamePage
